/** Yeelight free-shipping progress — VAT-inclusive cart total */
if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    connectedCallback() { this.updateProgress(); }
    updateProgress() {
      const total = Number(this.dataset.cartTotal || 0);
      const minimum = Math.max(1, Math.round(Number(this.dataset.minimum || 0) * (Shopify.currency.rate || 1)));
      const pct = Math.max(0, Math.min(100, (total / minimum) * 100));
      const bar = this.querySelector('.free-shipping--percentage');
      const progress = this.querySelector('.free-shipping--bar');
      const remainingText = this.querySelector('.free-shipping--text-remaining');
      const fullText = this.querySelector('.free-shipping--text-full');
      const amount = this.querySelector('.free-shipping--remaining-amount');
      if (bar) bar.style.width = pct + '%';
      if (progress) progress.setAttribute('aria-valuenow', Math.round(pct));
      if (total < minimum) {
        const remaining = minimum - total;
        if (amount) amount.textContent = formatMoney(remaining, window.theme.settings.money_with_currency_format || '$' + '{{amount}}');
        if (remainingText) remainingText.hidden = false;
        if (fullText) fullText.hidden = true;
      } else {
        if (remainingText) remainingText.hidden = true;
        if (fullText) fullText.hidden = false;
      }
    }
  }
  customElements.define('free-shipping', FreeShipping);
}